
import React from 'react';
import { Copy, Pencil, Trash2, Download, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

interface ViewModeProps {
  track: {
    id: string;
    spotifyUrl: string;
    downloadCount: number;
  };
  onCopyUrl: (id: string) => void;
  onEditClick: () => void;
  onDeleteClick: (id: string) => void;
  formatDate: (dateString: string) => string;
  isEditing?: boolean;
}

const ViewMode: React.FC<ViewModeProps> = ({
  track,
  onCopyUrl,
  onEditClick,
  onDeleteClick,
  formatDate,
  isEditing = false
}) => {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <>
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center">
              <Download size={14} className="mr-1.5 opacity-70" />
              <p className="font-medium">{track.downloadCount}</p>
            </div>
          </div>
          
          <div className="flex flex-wrap gap-2 justify-end">
            <Button variant="outline" size="sm" className="h-8 px-3 rounded-md transition-colors hover:bg-secondary" onClick={() => onCopyUrl(track.id)}>
              <Copy size={14} className="mr-1.5 opacity-70" />
              <span className="text-xs font-medium">Copy Link</span>
            </Button>
            <Button 
              variant={isEditing ? "default" : "outline"}
              size="sm"
              className={`h-8 px-3 rounded-md transition-all ${isEditing ? "bg-green-500 hover:bg-green-600 text-white" : "hover:bg-secondary"}`}
              onClick={onEditClick}
            >
              {isEditing ? (
                <>
                  <Check size={14} className="mr-1.5 opacity-70" />
                  <span className="text-xs font-medium">Update</span>
                </>
              ) : (
                <>
                  <Pencil size={14} className="mr-1.5 opacity-70" />
                  <span className="text-xs font-medium">Edit</span>
                </>
              )}
            </Button>
            <Button 
              variant="outline" 
              size="sm"
              className="h-8 px-3 rounded-md text-[#ea384c] hover:bg-destructive/10 transition-colors"
              onClick={() => onDeleteClick(track.id)}
            >
              <Trash2 size={14} className="mr-1.5 opacity-70" />
              <span className="text-xs font-medium">Delete</span>
            </Button>
          </div>
        </>
      ) : (
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0 flex items-center">
            <Download size={14} className="mr-1.5 opacity-70" />
            <p className="font-medium">{track.downloadCount}</p>
          </div>
          
          <div className="flex gap-2 ml-auto">
            <Button variant="outline" size="sm" className="h-8 px-3 rounded-md transition-colors hover:bg-secondary" onClick={() => onCopyUrl(track.id)}>
              <Copy size={14} className="mr-1.5 opacity-70" />
              <span className="text-xs font-medium">Copy Link</span>
            </Button>
            <Button 
              variant={isEditing ? "default" : "outline"}
              size="sm"
              className={`h-8 px-3 rounded-md transition-all ${isEditing ? "bg-green-500 hover:bg-green-600 text-white" : "hover:bg-secondary"}`}
              onClick={onEditClick}
            >
              {isEditing ? (
                <>
                  <Check size={14} className="mr-1.5 opacity-70" />
                  <span className="text-xs font-medium">Update</span>
                </>
              ) : (
                <>
                  <Pencil size={14} className="mr-1.5 opacity-70" />
                  <span className="text-xs font-medium">Edit</span>
                </>
              )}
            </Button>
            <Button 
              variant="outline" 
              size="sm"
              className="h-8 px-3 rounded-md text-[#ea384c] hover:bg-destructive/10 transition-colors"
              onClick={() => onDeleteClick(track.id)}
            >
              <Trash2 size={14} className="mr-1.5 opacity-70" />
              <span className="text-xs font-medium">Delete</span>
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewMode;
